// src/components/ConfirmSubscription.jsx
import React, { useState } from "react";
import { getAuth } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import { RAZORPAY_KEY_ID } from "../config/razorpay";




const ConfirmSubscription = ({ planName, amount, slot, rotisPerDay, address, startDate, name, phone, discount = 0, couponCode = "" }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const finalAmount = amount - discount;
  const auth = getAuth();
  const navigate = useNavigate();

  const handlePayment = async () => {
    setLoading(true);
    setStatus(null);
    try {
    const user = auth.currentUser;
    if (!user) {
        setStatus("❌ Please login to continue.");
        setLoading(false);
      return;
    }
      // 1. Create Razorpay Order
      const res = await fetch("https://createrazorpayorder-swz7s7kyqq-uc.a.run.app",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: finalAmount,
        receipt: `receipt_${Date.now()}`,
        planName,
          }),
        }
      );
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const data = await res.json();
      const { order } = data;
      
      if (!order?.id) {
        throw new Error("Failed to create Razorpay order");
      }
      // 2. Launch Razorpay Checkout
      console.log("RAZORPAY_KEY_ID:", RAZORPAY_KEY_ID); // Debug log
      const options = {
        key: RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: "INR",
        name: "JR-Home Made Foods",
        description: planName,
        order_id: order.id,
        handler: async function (response) {
          try {
            // 3. Verify + Save Subscription
            const token = await user.getIdToken();
            const verifyRes = await fetch(
              "https://verifyrazorpaypayment-swz7s7kyqq-uc.a.run.app",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
            subscriptionData: {
              planName,
                    amount,
                    discount,
                    couponCode,
                    slot,
                    address,
                    startDate,
                    name,
                    phone,
                  },
                }),
              }
            );
            
            if (!verifyRes.ok) {
              throw new Error(`Verification HTTP error! status: ${verifyRes.status}`);
            }
            
            const result = await verifyRes.json();
            if (result?.success) {
              setStatus("✅ Payment Successful! Subscription saved.");
              setTimeout(() => navigate('/myplan'), 1500);
            } else {
              setStatus("⚠️ Payment was successful, but saving failed.");
            }
          } catch (error) {
            console.error("❌ Backend verification failed", error);
            setStatus("❌ Payment succeeded, but verification failed.");
          } finally {
            setLoading(false);
          }
        },
        prefill: {
          name: name || user.displayName || "Customer",
          email: user.email || "",
          contact: phone || user.phoneNumber || "",
        },
        theme: { color: "#059669" },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("❌ Razorpay Init Error:", err);
      setStatus("❌ Payment failed to start.");
      setLoading(false);
    }
  };

  return (
    <div className="p-4 text-center bg-green-50 rounded-xl border border-green-200 shadow mt-6 max-w-md mx-auto">
      <h2 className="text-xl font-semibold text-green-700 mb-3">Confirm Your Plan</h2>
      <div className="space-y-1 text-sm mb-4">
      <p><strong>Plan:</strong> {planName}</p>
      <p><strong>Amount:</strong> <span className="text-green-700 font-bold text-lg">₹{amount}</span></p>
        {discount > 0 && (
          <p><strong>Discount:</strong> <span className="text-green-600">-₹{discount}</span></p>
        )}
        <p><strong>To Pay:</strong> <span className="text-green-700 font-bold text-lg">₹{finalAmount}</span></p>
      {slot && <p><strong>Delivery Slot:</strong> {slot}</p>}
      {typeof rotisPerDay !== "undefined" && (
        <p><strong>Rotis per Day:</strong> {rotisPerDay}</p>
      )}
      {startDate && <p><strong>Start Date:</strong> {startDate}</p>}
      {name && <p><strong>Name:</strong> {name}</p>}
      {phone && <p><strong>Phone:</strong> {phone}</p>}
        {address && (
          <p><strong>Address:</strong><br />
            <span className="text-gray-600">{address}</span>
          </p>
        )}
        {couponCode && <p><strong>Coupon:</strong> <span className="text-blue-700">{couponCode}</span></p>}
      </div>
      <button
        onClick={handlePayment}
        className="w-full py-3 px-6 rounded-lg font-semibold text-white bg-green-600 hover:bg-green-700 transform hover:scale-105 transition-all shadow-lg"
        disabled={loading}
      >
        {loading ? "Processing..." : "Pay with Razorpay"}
      </button>
      {status && <p className="mt-4 text-sm font-medium">{status}</p>}
      <div className="text-xs text-gray-500 text-center mt-2">
        🔒 Secure payment powered by Razorpay
      </div>
    </div>
  );
};

export default ConfirmSubscription;
